"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToDesktop = exports.ToLaptop = exports.ToTablet = exports.ToPhone = exports.FromDesktop = exports.FromLaptop = exports.FromTablet = exports.FromPhone = exports.NotDesktop = exports.NotLaptop = exports.NotTablet = exports.NotPhone = exports.Desktop = exports.Laptop = exports.Tablet = exports.Phone = exports.breakpoints = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactResponsive = _interopRequireDefault(require("react-responsive"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var bp;
var _default = _reactResponsive.default; // min widths to activate breakpoint

exports.default = _default;
var breakpoints = bp = {
  phone: 0,
  tablet: 752,
  laptop: 972,
  desktop: 1172
}; // Content will only be visible ** within ** the named breakpoint

exports.breakpoints = breakpoints;

var Phone = function Phone(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    minWidth: bp.phone,
    maxWidth: bp.tablet - 1
  }, props));
};

exports.Phone = Phone;

var Tablet = function Tablet(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    minWidth: bp.tablet,
    maxWidth: bp.laptop - 1
  }, props));
};

exports.Tablet = Tablet;

var Laptop = function Laptop(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    minWidth: bp.laptop,
    maxWidth: bp.desktop - 1
  }, props));
};

exports.Laptop = Laptop;

var Desktop = function Desktop(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    minWidth: bp.desktop
  }, props));
}; // Content will only be visible ** outside ** the named breakpoint


exports.Desktop = Desktop;

var NotPhone = function NotPhone(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    query: "(max-width: ".concat(bp.phone - 1, "px), (min-width: ").concat(bp.tablet, "px)")
  }, props));
};

exports.NotPhone = NotPhone;

var NotTablet = function NotTablet(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    query: "(max-width: ".concat(bp.tablet - 1, "px), (min-width: ").concat(bp.laptop, "px)")
  }, props));
};

exports.NotTablet = NotTablet;

var NotLaptop = function NotLaptop(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    query: "(max-width: ".concat(bp.laptop - 1, "px), (min-width: ").concat(bp.desktop, "px)")
  }, props));
};

exports.NotLaptop = NotLaptop;

var NotDesktop = function NotDesktop(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    query: "(max-width: ".concat(bp.desktop - 1, "px)")
  }, props));
}; // Sets the ** minimum ** breakpoint at which the content is visible


exports.NotDesktop = NotDesktop;

var FromPhone = function FromPhone(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    minWidth: bp.phone
  }, props));
};

exports.FromPhone = FromPhone;

var FromTablet = function FromTablet(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    minWidth: bp.tablet
  }, props));
};

exports.FromTablet = FromTablet;

var FromLaptop = function FromLaptop(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    minWidth: bp.laptop
  }, props));
};

exports.FromLaptop = FromLaptop;

var FromDesktop = function FromDesktop(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    minWidth: bp.desktop
  }, props));
}; // Sets the ** maximum ** breakpoint at which the content is visible


exports.FromDesktop = FromDesktop;

var ToPhone = function ToPhone(props) {
  // lol
  return _react.default.createElement(_reactResponsive.default, _extends({
    maxWidth: bp.phone - 1
  }, props));
};

exports.ToPhone = ToPhone;

var ToTablet = function ToTablet(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    maxWidth: bp.tablet - 1
  }, props));
};

exports.ToTablet = ToTablet;

var ToLaptop = function ToLaptop(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    maxWidth: bp.laptop - 1
  }, props));
};

exports.ToLaptop = ToLaptop;

var ToDesktop = function ToDesktop(props) {
  return _react.default.createElement(_reactResponsive.default, _extends({
    maxWidth: bp.desktop - 1
  }, props));
};

exports.ToDesktop = ToDesktop;